/* Created by Interactive 63 - https://interactive63.com */
/**
 * The order layers are listed in: front to back, so the layer drawn on top comes first. The SVG
 * source and the element table keep document order (back to front); this is only for display.
 */
import type { ElementId, Project } from './types';

/**
 * Position of every element in the layer list, a group before its contents. Elements outside the
 * tree, such as gradient stops, follow the tree in ID order.
 */
export function listOrder(project: Project): Map<ElementId, number> {
  const order = new Map<ElementId, number>();
  const visit = (id: ElementId): void => {
    if (order.has(id) || !project.elements[id]) return;
    order.set(id, order.size);
    const childIds = project.elements[id].childIds;
    for (let i = childIds.length - 1; i >= 0; i -= 1) visit(childIds[i] ?? '');
  };
  for (let i = project.rootIds.length - 1; i >= 0; i -= 1) visit(project.rootIds[i] ?? '');
  const treeSize = order.size;
  for (const id of Object.keys(project.elements)) {
    if (!order.has(id)) order.set(id, treeSize + Number(id.slice(1)));
  }
  return order;
}
